import get from 'lodash/get';
import isObject from 'lodash/isObject';

export class StateTimeTrackerService {
  state = null;

  static setupState = (route) => ({
    timestamp: Date.now(),
    route: route || 'none',
  });

  // eslint-disable-next-line consistent-return
  static getPageLoadTime() {
    const timing = get(window, 'performance.timing', null);
    if (!isObject(timing)) {
      return '';
    }

    const startTime = timing.redirectStart || timing.fetchStart || timing.requestStart;
    const endTime = timing.domContentLoadedEventEnd || timing.domInteractive || timing.domComplete || timing.loadEventComplete;
    if (startTime && endTime && startTime < endTime) {
      return (endTime - startTime).toString();
    }
  }

  start(route) {
    if (!this.state) {
      // case when we track DOMReady + first successful $stateChangeSuccess, only once
      return;
    }
    this.state = StateTimeTrackerService.setupState(route);
  }

  end(route) {
    if (!this.state) {
      // case when we track DOMReady + first successful $stateChangeSuccess, only once
      const time = StateTimeTrackerService.getPageLoadTime();
      this.state = StateTimeTrackerService.setupState('init');
      return time;
    }
    if (this.state.route === route) {
      return (Date.now() - this.state.timestamp).toString();
    }
    return null;
  }
}

const StateTimeTracker = new StateTimeTrackerService();
export default StateTimeTracker;
